"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textbox = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Tokens = __importStar(require("../../../../../styles/tokens"));
const TextareaAutosize_styles_1 = require("../../../../TextareaAutosize/TextareaAutosize.styles");
const ComposeContext_1 = require("../../ComposeContext");
const StyledTextArea = (0, styled_components_1.default)(TextareaAutosize_styles_1.StyledTextareaAutoSize) `
    padding: 1rem;
    border: 1px solid ${Tokens.COLOURS.greyscale.silver};
    border-radius: ${Tokens.BORDERS.radius};
    font-family: ${Tokens.TYPOGRAPHY.body.base.fontFamily};
    font-size: 1rem;
    resize: none !important;
    line-height: 2rem;
    padding-bottom: 0;
    display: block;
`;
const Textbox = ({ messageBody, onMessageBodyChange, maxMessageLength, placeholder, customTextarea, }) => {
    var _a;
    let customTextareaNodeType = ""; // Identify the type of custom render
    if (customTextarea === null || customTextarea === void 0 ? void 0 : customTextarea.type) {
        customTextareaNodeType =
            typeof customTextarea.type === "string"
                ? customTextarea.type
                : (_a = customTextarea.type.displayName) !== null && _a !== void 0 ? _a : customTextarea.type.name;
    }
    // Check accepted custom textarea type - semantic textarea, styled textarea, nhs design lib textarea
    if (customTextarea &&
        !(customTextareaNodeType === "textarea" ||
            customTextareaNodeType === "styled.textarea" ||
            customTextareaNodeType === "Textarea")) {
        throw new Error("Only a textarea element can be passed as a custom render to Compose.Textbox");
    }
    const { canCompose, isSending } = (0, ComposeContext_1.useCompose)();
    const [disableInputs, setDisableInputs] = (0, react_1.useState)(true);
    // N.B. We change the disabled value like this rather than just pure calculation so that it doesn't change
    // between the server-side and client-side render when the context is updated
    (0, react_1.useEffect)(() => {
        setDisableInputs(isSending || !canCompose);
    }, [isSending, canCompose]);
    const handleMessageBodyChange = (e) => {
        onMessageBodyChange(e.currentTarget.value);
    };
    if (customTextarea) {
        return react_1.default.cloneElement(customTextarea, {
            value: messageBody,
            onChange: handleMessageBodyChange,
            "data-testid": "message-body",
            disabled: disableInputs,
            maxLength: maxMessageLength,
        });
    }
    return (react_1.default.createElement(StyledTextArea, { required: true, autoFocus: true, value: messageBody, onChange: handleMessageBodyChange, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Please enter your message", "data-testid": "message-body", disabled: disableInputs, minRows: 3, maxLength: maxMessageLength }));
};
exports.Textbox = Textbox;
//# sourceMappingURL=Textbox.js.map